import { Skeleton } from '@mui/material';
import 'app/agriculture/components/Subtitle/Subtitle.scss';

export function SubtitleSkeleton() {
    return (
        <p className="Subtitle">
            <Skeleton variant="text" />
        </p>
    );
}
